const cacheVersion = 1;
const cacheName = `thetan-storage-${cacheVersion}`;
export const hasCached = async url => {
  const cachedData = await getCachedData(cacheName, url);
  return !!cachedData;
};
export const getData = async url => {
  try {
    let cachedData = await getCachedData(cacheName, url);

    if (cachedData) {
      return cachedData;
    }

    await setCachedData(url);
    cachedData = await getCachedData(cacheName, url);
    return cachedData;
  } catch (error) {
    return undefined;
  }
};
export const setCachedData = async url => {
  try {
    const cacheStorage = await caches.open(cacheName);
    await cacheStorage.add(url);
    await deleteOldCaches(cacheName);
    return;
  } catch (error) {
    return;
  }
}; // Get data from the cache.

const getCachedData = async (cacheName, url) => {
  try {
    const cacheStorage = await caches.open(cacheName);
    const cachedResponse = await cacheStorage.match(url);

    if (!cachedResponse || !cachedResponse.ok) {
      return undefined;
    }

    return await cachedResponse.arrayBuffer();
  } catch (error) {
    return undefined;
  }
}; // Delete any old caches to respect user's disk space.


const deleteOldCaches = async currentCache => {
  const keys = await caches.keys();

  for (const key of keys) {
    const isOurCache = key.startsWith('thetan-storage-');

    if (currentCache === key || !isOurCache) {
      continue;
    }

    caches.delete(key);
  }
};